import {
  setDefaultBabyTexts,
  setModalVisible } from '../redux/actions/ui/babyPage';
import { getContext } from '../redux/helpers/getParams';
import { postTextData } from '../redux/helpers/texts';
import { addText } from '../redux/actions/entities/texts';
import { addTextToPage } from '../redux/actions/entities/pages';
import { getRatio } from '../redux/helpers/index';


export const BOYTEXTCOLOR = '#57bbfb';
export const GIRLTEXTCOLOR = '#f7a9c1';
export const DEFAULT_INSERTED_BOY_COLOR = '#0d659c';
export const DEFAULT_INSERTED_GIRL_COLOR = '#c1909f';
const FONT = 'DJB_Baby_Bump';
const DEFAULTTEXTPROPS = {
  fontSize: 50,
  font: FONT,
  shadow: false,
  stroke: false,
  strokeColor: '',
  isMoveable: false,
  isSpine: false,
  context: getContext(),
};

export function getBabyDefaultTextCoords() {
  return {
    name: {
      left: 40.3,
      top: 43.5,
    },
    date: {
      left: 40.3,
      top: 70.2,
    },
    time: {
      left: 40.3,
      top: 98.2,
    },
    city: {
      left: 40.3,
      top: 128.7,
    },
    weight: {
      left: 40.3,
      top: 157.5,
    },
    length: {
      left: 40.3,
      top: 186.3,
    },
    mother: {
      left: 40.3,
      top: 215.1,
    },
    father: {
      left: 40.3,
      top: 242.0,
    },
  };
}

export function babyInputs() {
  return ['name', 'date', 'time', 'city', 'weight', 'length', 'mother', 'father'];
}

export function insertedTextCoords(texts) {
  const inputNames = babyInputs();

  const generateCoords = {};
  inputNames.forEach((element) => {
    const selectedText = Object.values(texts).find(text => text.babyPlaceholderText === element);
    const { positions, images } = selectedText;
    generateCoords[selectedText.babyPlaceholderText] = {
      left: (positions.x + images.thumbnail.width),
      top: positions.y,
    };
  });

  return generateCoords;
}

export function mergeDefaultData(bookId) {
  return Object.assign(DEFAULTTEXTPROPS, { bookId });
}

function getSelectorLimitCoords(selector) {
  return document.querySelector(selector).getBoundingClientRect();
}

export function generateText(textProperties, pageId, textId, dispatch) {
  return new Promise(async (resolve) => {
    dispatch(addText(textProperties));
    await postTextData(textProperties, dispatch);
    dispatch(addTextToPage(pageId, textId));
    resolve(true);
  });
}

export function calculateXYPosition(left, top, layoutHeight, bookHeight) {
  const dragWrapper = getSelectorLimitCoords('.dragLimit');
  const interactiveLayer = getSelectorLimitCoords('.InteractiveLayer');

  return {
    x: ((dragWrapper.left - interactiveLayer.left) + (left * getRatio(layoutHeight, bookHeight))),
    y: (((dragWrapper.top - interactiveLayer.top) + (top * getRatio(layoutHeight, bookHeight)))),
  };
}


export async function generateBabyBookTexts(dispatch) {
  dispatch(setDefaultBabyTexts(true));
  dispatch(setModalVisible(true));
}




// WEBPACK FOOTER //
// ./src/helpers/babyBookHelper.jsx